import { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { createQueryClient } from '@/api/queryClient';
import { useSessionBootstrap } from '@/auth/useAuth';
import { applyTheme, useThemeStore } from '@/lib/theme';
import { createAppRouter } from '@/routes/router';

function Bootstrapped() {
  const state = useSessionBootstrap();
  const [router] = useState(createAppRouter);
  const { t } = useTranslation();
  if (state === 'pending') {
    return <div className="flex h-full items-center justify-center text-sm text-muted-foreground">{t('common.loading')}</div>;
  }
  return <RouterProvider router={router} />;
}

export function App() {
  const [queryClient] = useState(createQueryClient);
  const theme = useThemeStore((s) => s.preference);

  useEffect(() => {
    applyTheme(theme);
    if (theme !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => applyTheme('system');
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [theme]);

  return (
    <QueryClientProvider client={queryClient}>
      <Bootstrapped />
      <Toaster position="bottom-right" richColors closeButton theme={theme} />
    </QueryClientProvider>
  );
}
